import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newUnitButton: {
    id: 'course-authoring.course-outline.subsection.button.new-unit',
    defaultMessage: 'Nueva unidad',
  },
  pasteButton: {
    id: 'course-authoring.course-outline.subsection.button.paste-unit',
    defaultMessage: 'Pegar unidad',
  },
});

export default messages;
